import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { initialState } from './state';
import { setCategorySubline } from './actions';

const reducer = reducerWithInitialState(initialState).case(
    setCategorySubline.done,
    (state, { result }) => ({
        ...state,
        categorySubline: result,
    }),
);

export default reducer;
